<template lang="pug">
.k-page.page
  slot
  .bottom-spacer
</template>

<script lang="js">
import { mapGetters, mapMutations } from 'vuex'
// import { Logger } from '@/lib/logger'

export default {
  name: 'PageBlock',
  mixins: [],
  components: {},
  props: {},
  data() {
    return {
      scroll: 0,
      teardouwn: false
    }
  },
  created() {},
  mounted() {
    if ( this.layout !== 'suave' ) {
      this.$el.addEventListener( 'scroll', this.onScroll )
      this.teardouwn = true
    }
  },
  methods: {
    ...mapMutations([ 'scrolledDown', 'scrolledUp', 'scrollAtTop' ]),
    onScroll( $event ) {
      // Logger.debug( 'onScroll', '<KPage>', $event )()
      const scroll = this.$el.scrollTop
      if ( scroll < this.scroll ) {
        this.scrolledUp( scroll )
      } else if ( scroll > this.scroll ) {
        this.scrolledDown( scroll )
      }
      if ( !scroll ) this.scrollAtTop()
      this.scroll = scroll
    }
  },
  beforeDestroy() {
    if ( this.teardouwn ) {
      this.$el.removeEventListener( 'scroll', this.onScroll )
    }
  },
  computed: {
    ...mapGetters([ 'layout' ])
  }
}
</script>

<style lang="scss">
.k-page {
}
</style>
